// TaskReminderPage.tsx
import React, { useState, useCallback, useEffect } from 'react';
// import TaskReminderIssue from '../components/TaskReminderIssue';
import Modal from '../../components/Modal';
import { useTranslation } from 'react-i18next';
import TaskReminderList from '../../components/TaskReminder/TaskReminderList';
import { useNavigate } from 'react-router-dom';
import NewTaskReminder from '../../components/TaskReminder/NewTaskReminder';
import { TaskReminder, User } from '../../utils/types';
import WhatsAppSender from '../../components/TaskReminder/WhatsAppSender';
import { appSettings, fetchTaskReminderList, fetchWhatsAppRecipients, sendWhatsAppMessage } from '../../utils/api';
import { toast } from 'react-toastify';
import { hasRole } from '../../utils/auth';


const TaskReminderPage: React.FC = () => {

    const navigate = useNavigate();

    useEffect(() => {
        if (!hasRole(['super_admin'])) {
            navigate('/');
        }
    }, [navigate]);


    const { t } = useTranslation();

    // const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState<'tasks' | 'settings'>('tasks');
    const [key, setKey] = useState(0); // Used to force re-render of TaskReminderList
    const [notifiedTaskIds, setNotifiedTaskIds] = useState<Set<number>>(new Set());

    const handleTaskCreated = useCallback(() => {
        // Increment key to force TaskReminderList to re-fetch tasks
        setKey(prevKey => prevKey + 1);
    }, []);

    const [modal, setModal] = useState<null | 'lowtask-reminder' | 'qrscan' | 'qrgenerator' | 'multiqrpdf' | 'scanhistory' | 'reserve' | 'release' | 'receive' | 'issue' | 'adjust'>(null);

    return (
        <div className="container mx-0 p-1 pb-14 flex flex-col items-center w-full h-screen bg-white">

            <div className="flex-1 w-full h-full relative overflow-y-auto">
                {/* Main Content Scrollable Area */}
                <div className="w-full mx-auto md:mr-4 mb-4">
                    <div className=" bg-white border-b border-gray-200 px-4">
                        <nav className="   -mb-px flex space-x-8" aria-label="Tabs">
                            <button
                                onClick={() => setActiveTab('tasks')}
                                className={`${activeTab === 'tasks' ? 'border-indigo-500 text-indigo-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'} whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm`}
                            >
                                {t('taskReminder.newTaskReminder')}
                            </button>
                            <button
                                onClick={() => setActiveTab('settings')}
                                className={`${activeTab === 'settings' ? 'border-indigo-500 text-indigo-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'} whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm`}
                            >
                                {t('taskReminder.settingsTitle')}
                            </button>
                        </nav>
                    </div>

                    {activeTab === 'tasks' && (
                        <div className="mt-4 bg-indigo-100 p-4 rounded-xl border border-indigo-200 shadow-md">

                            <NewTaskReminder onCreated={handleTaskCreated} onClose={() => { /* Optionally handle close */ }} />

                        </div>
                    )}
                    {activeTab === 'settings' &&
                        <div className="mt-4 bg-green-200 p-4 rounded-xl border border-green-200 shadow-md">

                            <WhatsAppSender />

                        </div>
                    }

                    <TaskReminderList key={key} />

                </div>
            </div>



            <div className="task-reminder-modal-container ">

                {/* <Modal isOpen={modal === 'issue'} onClose={() => setModal(null)} title="TaskReminder Issue">
                    <TaskReminderIssue />
                </Modal>
                <Modal isOpen={modal === 'adjust'} onClose={() => setModal(null)} title="TaskReminder Adjustment">
                    <TaskReminderAdjust />
                </Modal> */}
            </div>

        </div>
    );
};

export default TaskReminderPage;
